function getMajor(): string {
  return (import.meta.env.PACKAGE_VERSION ?? '').split('.')[0] || 'dev'
}

function getMinor(): string {
  return import.meta.env.VITE_VERSION_MINOR || '0'
}

function getPatch(): string {
  return import.meta.env.VITE_VERSION_PATCH || '0'
}

export function buildAppVersion(): string {
  return `${getMajor()}.${getMinor()}.${getPatch()}`
}
